'use client';

import 'dayjs/locale/ar';
import 'dayjs/locale/en';

import '@/styles/globals.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { Toaster } from 'react-hot-toast';
import { AnalyticsProvider } from '@/components/analytics-provider';
import { TrpcProvider } from '@/providers/trpc-provider';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Suspense, useEffect } from 'react';

export function ClientProviders({
  locale,
  children,
}: {
  locale: string;
  children: React.ReactNode;
}) {
  const queryClient = new QueryClient();
  dayjs.locale(locale);

  useEffect(() => {
    AOS.init({ duration: 600, offset: 400, once: true, debounceDelay: 100 });
  }, []);

  return (
    <TrpcProvider>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={null}>
          <AnalyticsProvider />
        </Suspense>
        {children}
        <Toaster />
      </QueryClientProvider>
    </TrpcProvider>
  );
}
